export interface SortSetting {
  id: string;
  messageCode: string;
  fieldName?: string;
  direction?: string;
}

const SortField = {
  NAME: 'name.keyword',
  PRICE: 'cachedPriceValue',
};

const StandardSort = {
  RELEVANCE: {
    id: '0',
    messageCode: 'relevance',
    fieldName: undefined,
    direction: undefined,
  },
  NAME_ASC: {
    id: '1',
    messageCode: 'name.asc',
    fieldName: SortField.NAME,
    direction: 'asc',
  },
  NAME_DESC: {
    id: '2',
    messageCode: 'name.desc',
    fieldName: SortField.NAME,
    direction: 'desc',
  },
  PRICE_ASC: {
    id: '3',
    messageCode: 'price.asc',
    fieldName: SortField.PRICE,
    direction: 'asc',
  },
  PRICE_DESC: {
    id: '4',
    messageCode: 'price.desc',
    fieldName: SortField.PRICE,
    direction: 'desc',
  },
};

export const SortUtils = {
  getBrowseSortSettings(): SortSetting[] {
    return [StandardSort.NAME_ASC, StandardSort.NAME_DESC, StandardSort.PRICE_ASC, StandardSort.PRICE_DESC];
  },
  getSearchSortSettings(): SortSetting[] {
    return [
      StandardSort.RELEVANCE, StandardSort.NAME_ASC, StandardSort.NAME_DESC,
      StandardSort.PRICE_ASC, StandardSort.PRICE_DESC,
    ];
  },
};
